import React from 'react';
import { object, string, func } from 'prop-types';
import classNames from 'classnames';
import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';
import Divider from 'components/Ui/Divider';
import Tmpl from 'components/Tmpl';
import Step from './Step';

import styles from './flow.scss';

const CONTENT_KEYS = {
  title: 'Title',
  subtitle: 'Subtitle',
  steps: 'Orders',
  ctaButton: 'Start Delivery Order',
};

const DeliveryFlow = ({ content, className, ctaClick }) => (
  <div className={classNames(styles.flow, className)}>
    <div className={classNames(styles.content)}>
      {content.title && (
        <>
          <h1 className={styles.title}>
            <Tmpl>{content.title}</Tmpl>
          </h1>
          <Divider className={styles.divider} />
        </>
      )}
      <h2 className={styles.subtitle}>{content.subtitle}</h2>
      <ol className={styles.steps}>
        {content.steps.fields.features.map((document, index) => (
          <Step key={document.sys.id} document={document} order={index + 1} />
        ))}
      </ol>
      <div className={styles.ctaButton}>
        <Button document={content.ctaButton} onClick={ctaClick} />
      </div>
    </div>
  </div>
);

DeliveryFlow.propTypes = {
  content: object,
  className: string,
  ctaClick: func,
};

export default withContent(CONTENT_KEYS)(DeliveryFlow);
